"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Relation = void 0;
const falconone_1 = require("../../private/api-services/falconone");
const authData_1 = require("../../private/ephemeral/authData");
class Relation {
    /**
     * Creates an instance of Collection.
     * @memberof Collection
     */
    constructor() {
        if (!(authData_1.Auth.getUserToken() && authData_1.Auth.getDomainToken())) {
            throw new Error("Cannot use Node service without authenticated user and opened domain!, " +
                "please use the Authenticator service first");
        }
        this.api = new falconone_1.FalconOne(authData_1.Auth.getUserToken(), authData_1.Auth.getDomainToken());
    }
    /**
     * @deprecated
     *
     * @param {number} relationId
     * @returns {Promise<iRelation>}
     * @memberof Relation
     */
    getFull(relationId) {
        return this.api.get(`relation/${relationId}/full`);
    }
    /**
     *
     *
     * @param {number} relationId
     * @returns {Promise<iRelation>}
     * @memberof Relation
     */
    get(relationId) {
        return this.api.get(`relation/${relationId}`);
    }
    /**
     * Create a Relation
     *
     * @param {Partial<iRelation>} relation
     * @returns {Promise<iRelation>}
     * @memberof Relation
     */
    create(relation) {
        return this.api.post(`relation`, relation);
    }
    /**
     * Create Many Relations
     *
     * @param {Array<Partial<iRelation>>} relations
     * @returns {Promise<iRelation[]>}
     * @memberof Relation
     */
    createMany(relations) {
        return this.api.post(`relation/many`, relations);
    }
    /**
     * Update a Relation
     *
     * @param {Partial<iRelation>} relation
     * @returns {Promise<iRelation>}
     * @memberof Relation
     */
    update(relation) {
        return this.api.patch(`relation/${relation.id}`, relation);
    }
    /**
     *
     *
     * @param {number} relationId
     * @returns {Promise<void>}
     * @memberof Relation
     */
    destroy(relationId) {
        return this.api.delete(`relation/${relationId}`);
    }
    /**
     *
     *
     * @param {object} query: Query Language Basics, @see https://sailsjs.com/documentation/concepts/models-and-orm/query-language
     * @returns {Promise<iRelation[]>}
     * @memberof Relation
     */
    query(query) {
        return this.api.postSearchQuery("relation/find", query);
    }
    /**
     * @param {*} relationId
     * @param {*} resourceId
     * @returns {Promise<iRelation>}
     * @memberof Relation
     */
    attachResource(relationId, resourceId) {
        return this.api.post(`relation/${relationId}/resources/${resourceId}`, {});
    }
    /**
     * @param {*} relationId
     * @param {*} relationId
     * @returns {Promise<iRelation>}
     * @memberof Relation
     */
    addLabel(relationId, labelId) {
        return this.api.put(`relation/${relationId}/labels/${labelId}`, {});
    }
    /**
     * @param {*} relationId
     * @param {*} relationId
     * @returns {Promise<any>}
     * @memberof Relation
     */
    removeLabel(relationId, labelId) {
        return this.api.delete(`relation/${relationId}/labels/${labelId}`);
    }
    /**
     * Find all relations in a set of nodes
     * @param nodeUuids a list of node uuids
     */
    findInNodeList(nodeUuids) {
        return this.api.post(`relation/inNodeSet`, {
            nodeUuids
        });
    }
    /**
     * Create or Update relation
     *
     * @param {Partial<iRelation>} relations
     * @returns {Promise<iRelation>}
     * @memberof Relation
     */
    createOrUpdate(relation) {
        console.log('updating', relation);
        return this.api.post(`relation/createOrUpdate`, relation);
    }
}
exports.Relation = Relation;
//# sourceMappingURL=data:application/json;base64,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